<template>
    <div class="modal" :class="{show: loading}" role="status" aria-live="polite"
         :aria-busy="loading ? 'true' : 'false'" :aria-hidden="loading ? 'false' : 'true'">
        <div class="panel">
            <div class="brand">해와달인테리어</div>
            <div class="spinner" aria-hidden="true"></div>
            <div class="text">loading...</div>
        </div>
    </div>
</template>

<script>
import {Vue, Component} from 'vue-property-decorator'

@Component
export default class Loading extends Vue {
    get loading () {
        return this.$store.getters.loading
    }
}
</script>

<style scoped lang="scss">
@import 'src/assets/style/common';
.modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    overflow: hidden;
    background-color: rgba($transparent-dark-theme, 0.8);
    z-index: 9999;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // visibility delays until the opacity fade-out finishes, so hide is smooth both ways
    transition: opacity 0.35s ease, visibility 0s linear 0.35s;
    &.show {
        opacity: 1;
        visibility: visible;
        pointer-events: auto;
        transition: opacity 0.35s ease, visibility 0s linear 0s;
    }
}

.panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.brand {
    letter-spacing: 1px;
}

.spinner {
    width: 26px;
    height: 26px;
    margin: 12px 0;
    border: 2px solid rgba($dark-theme, 0.25);
    border-top-color: $dark-theme;
    border-radius: 50%;
}

// only spin while visible (never animate an off-screen looping element)
.modal.show .spinner {
    animation: sm-spin 0.8s linear infinite;
}

.text {
    opacity: 0.7;
}

@keyframes sm-spin {
    to { transform: rotate(360deg); }
}

@media (prefers-reduced-motion: reduce) {
    .modal { transition: opacity 0.001ms; }
    .modal.show .spinner { animation: none; }
}
</style>
